export class Page {
  totalElements: 0;
  content: [];
}
